import { motion } from "framer-motion";
import { CAPABILITIES } from "./data";

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};

export const Capabilities = () => {
  return (
    <section id="capabilities" data-testid="capabilities-section" className="relative py-28 px-5">
      <div className="max-w-7xl mx-auto">
        <motion.div {...reveal} transition={{ duration: 0.6 }} className="max-w-2xl mb-14">
          <p className="font-mono text-xs tracking-[0.3em] uppercase overline mb-4">
            / Capabilities
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight txt-primary">
            All apps. <span className="text-gradient">All platforms.</span>
          </h2>
          <p className="mt-5 text-lg txt-soft">
            One studio for the entire stack — from native mobile to intelligent
            cloud backends. Whatever you're building, we engineer it end to end.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-6 auto-rows-[1fr] gap-4">
          {CAPABILITIES.map((c, i) => (
            <motion.div
              key={c.title}
              {...reveal}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              data-testid={`capability-card-${i}`}
              className={`group relative overflow-hidden rounded-3xl border hairline p-7 hover:border-purple-500/50 transition-all duration-300 shadow-[0_0_25px_rgba(99,102,241,0.06)] glass ${c.span}`}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${c.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
              <div className="absolute inset-0 circuit-grid opacity-30" />
              <div className="relative flex flex-col h-full">
                <p className="font-mono text-[11px] tracking-[0.2em] uppercase overline">
                  {c.tag}
                </p>
                <h3 className="font-heading text-2xl font-bold txt-primary mt-3">
                  {c.title}
                </h3>
                <p className="mt-3 txt-soft leading-relaxed flex-grow">{c.desc}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {c.stack.map((s) => (
                    <span key={s} className="font-mono text-[11px] px-2.5 py-1 rounded-md chip">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
